import { Fragment } from "react";

export const Words = ({ text, start = 0, className = "" }) => {
  const words = text.split(" ");
  return words.map((w, i) => (
    <Fragment key={i}>
      <span className="wr">
        <span className={className} style={{ "--i": start + i }}>{w}</span>
      </span>
      {i < words.length - 1 && " "}
    </Fragment>
  ));
};
